import styled from 'styled-components';
import UpBlueArrowSvg from '../../assets/wallet/up-blue.svg';

const UpBlueArrowIcon = styled(UpBlueArrowSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2.4rem'};
height: ${props => props.height || '2.4rem'};
display: flex;
`;

export default UpBlueArrowIcon;
